import styled from '@emotion/styled';
import { ImgWithFallback } from '../ImgWithFallback';

export const CabinContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
`;

export const CabinCard = styled.button`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: normal;
    width: 48%;
    border-radius: 6px;
    box-shadow: ${(props) => (props.disabled ? 'none' : '0px 6px 8px 0px rgba(0, 0, 0, 0.02)')};
    opacity: ${(props) => (props.disabled ? '0.5' : '1')};
    border: none;
    background: transparent;
    padding: 0;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export const CabinCardDetailsWrapper = styled.div<{ isCabinSelected?: boolean }>`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    align-items: flex-start;
    padding: 16px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    border-width: 0 2px 2px 2px;
    border-style: solid;
    border-color: ${(props) =>
        props.isCabinSelected
            ? props.theme.colors.azure['100']
            : props.theme.colors.whiteSmoke['100']};
`;

export const CabinCardDetails = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 14px;
`;

export const StyledCabinImage = styled(ImgWithFallback)`
    position: absolute;
    width: 100%;
    top: -30%;
    left: 0;
    right: 0;
`;

export const CabinImageWrapper = styled.div<{ isCabinSelected?: boolean }>`
    height: 120px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border: 2px solid ${(props) => props.theme.colors.azure['100']};
    border-width: ${(props) => (props.isCabinSelected ? '2px' : '0')};
    border-bottom: 0;
    position: relative;
    overflow: hidden;

    ${StyledCabinImage} {
        left: ${(prosp) => (prosp.isCabinSelected ? '0' : '1px')};
        right: ${(prosp) => (prosp.isCabinSelected ? '0' : '-1px')};
    }
`;

export const CabinTypeTitle = styled.p`
    margin: 0;
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
`;

export const CabinTypeDiscount = styled.span`
    color: #fff;
    background: ${(props) => props.theme.colors.watermelon['100']};
    border-radius: 4px;
    padding: 0 6px;
    margin-left: 8px;
    line-height: 16px;
`;

export const CabinTypePrice = styled.span<{ hasDiscount?: boolean }>`
    color: ${(props) =>
        props.hasDiscount
            ? props.theme.colors.watermelon['100']
            : props.theme.colors.gunmetal['70']};
    font-size: 14px;
    text-align: left;
    margin-top: 4px;
`;
